import React from "react";
import { Box, Typography, Step, StepLabel } from "@mui/material";
import { StyledStepper } from "../styles/StyledComponents";

const getStepHeader = (step) => {
  switch (step) {
    case 0:
      return {
        title: "I Tuoi Dati Personali",
        subtitle: "Compila tutti i campi richiesti",
      };
    case 1:
      return {
        title: "La Tua Situazione Lavorativa",
        subtitle: "Aiutaci a comprendere la tua occupazione",
      };
    case 2:
      return {
        title: "Beneficiario",
        subtitle: "Inserisci i dati del beneficiario della polizza",
      };
    case 3:
      return {
        title: "Questionario",
        subtitle: "Completa il questionario per la valutazione del rischio",
      };
    case 4:
      return {
        title: "Riepilogo",
        subtitle: "Verifica i dati inseriti prima di procedere",
      };
    default:
      return {
        title: "",
        subtitle: "",
      };
  }
};

const StepHeader = ({ activeStep, steps }) => {
  const header = getStepHeader(activeStep);

  return (
    <>
      <Box
        sx={{
          background: "linear-gradient(135deg, #ff6f00, #ff9800)",
          color: "white",
          py: 5,
          px: 4,
          textAlign: "center",
          borderRadius: 3,
          mb: 4,
          boxShadow: "0 8px 32px rgba(255, 111, 0, 0.3)",
        }}
      >
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {header.title}
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9, mb: 2 }}>
          {header.subtitle}
        </Typography>
      </Box>

      <StyledStepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>
              <Typography variant="caption">{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </StyledStepper>
    </>
  );
};

export default StepHeader;
